// SAYYÂDİ - Mock data layer (frontend-only teaser)
// Bu veriler ilerde gerçek backend ile değiştirilecektir.

import {
  Mic, Home, MessageCircle, User, Footprints, BookOpen, Moon, Music2,
  KeyRound, BookMarked, Layers, HelpCircle, CalendarDays, Radio,
  HeartHandshake, Bell, ClipboardList, History, Sparkles, Shuffle,
  SlidersHorizontal, Users, Play, FileText, Image as ImageIcon, Star
} from "lucide-react";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1668023020358-c7e4bc140dfb",
  dervishPraying: "https://images.pexels.com/photos/28543341/pexels-photo-28543341.jpeg",
  manuscript1: "https://images.unsplash.com/photo-1720701574998-d68020bce2bd?crop=entropy&cs=srgb&fm=jpg&q=85",
  manuscript2: "https://images.unsplash.com/photo-1720701575003-51dafcf39cb4?crop=entropy&cs=srgb&fm=jpg&q=85",
  lantern1: "https://images.unsplash.com/photo-1510218830377-2e994ea9087d?crop=entropy&cs=srgb&fm=jpg&q=85",
  lantern2: "https://images.unsplash.com/photo-1555488205-d5e67846cf40?crop=entropy&cs=srgb&fm=jpg&q=85",
  mosqueSunset: "https://images.unsplash.com/photo-1582631313764-62141d98b4bb?crop=entropy&cs=srgb&fm=jpg&q=85",
  mosqueSunset2: "https://images.unsplash.com/photo-1567712595315-545da0d341b2?crop=entropy&cs=srgb&fm=jpg&q=85",
  dome: "https://images.unsplash.com/photo-1670514862391-df20ad00b330",
  mosqueGolden: "https://images.unsplash.com/photo-1692433633910-9c5b4099e245",
  prayerBeads: "https://images.unsplash.com/photo-1742219335029-951834824ed2?crop=entropy&cs=srgb&fm=jpg&q=85",
  neyFlute: "https://images.unsplash.com/photo-1778323482605-c73eb9c367c2?crop=entropy&cs=srgb&fm=jpg&q=85",
  ornateBook: "https://images.unsplash.com/photo-1609599006353-e629aaabfeae?crop=entropy&cs=srgb&fm=jpg&q=85",
  quranBeads: "https://images.unsplash.com/photo-1616422840391-fa670d4b2ae7?crop=entropy&cs=srgb&fm=jpg&q=85",
  prayingHands: "https://images.unsplash.com/photo-1611513940806-80d6ed9fd7cc",
  mosqueDusk: "https://images.unsplash.com/photo-1537181534458-45dcee76ae90",
  whirlingDervish: "https://images.unsplash.com/photo-1764099363412-b6b708d0b713",
};

// Üst menü (header)
export const topNav = [
  { id: "home", label: "Ana Sayfa", icon: Home, to: "/" },
  { id: "about", label: "Hakkımızda", icon: HelpCircle, to: "/hakkimizda" },
  { id: "sources", label: "Kaynaklar", icon: BookOpen, to: "/kaynaklar" },
  { id: "contact", label: "İletişim", icon: MessageCircle, to: "/iletisim" },
];

// Sol kenar menüsü
export const sideNav = [
  { id: "home", label: "Ana Sayfa", icon: Home, to: "/" },
  { id: "mahmut-ai", label: "Mahmut Efendim AI", icon: MessageCircle, to: "/mahmut-efendim-ai" },
  { id: "mahmut-efendim", label: "Sohbet Arşivi", icon: User, to: "/mahmut-efendim" },
  { id: "ayak-izleri", label: "Dijital Ayak İzleri", icon: Footprints, to: "/ayak-izleri" },
  { id: "dergah-kutuphanesi", label: "Dergâh Kütüphanesi", icon: BookOpen, to: "/dergah-kutuphanesi" },
  { id: "kutuphane", label: "Dijital Kütüphane", icon: BookOpen, to: "/kutuphane" },
  { id: "dervisin-yolculugu", label: "Dervişin Yolculuğu", icon: Moon, to: "/dervisin-yolculugu" },
  { id: "kuran-dinle", label: "Kur’an Dinle ve Takip Et", icon: Mic, to: "/kuran-dinle" },
  { id: "ilahiler", label: "İlahiler", icon: Music2, to: "/ilahiler" },
  { id: "evrad-zikar", label: "Evrad & Zikâr", icon: KeyRound, to: "/evrad-zikar" },
  { id: "kasideler", label: "Kasideler", icon: BookMarked, to: "/kasideler" },
  { id: "konular", label: "Konular", icon: Layers, to: "/konular" },
  { id: "soru-cevap", label: "Soru Cevap Arşivi", icon: HelpCircle, to: "/soru-cevap" },
  { id: "haftalik-dersler", label: "Haftalık Dersler", icon: CalendarDays, to: "/haftalik-dersler" },
  { id: "canli-yayin", label: "Canlı Yayın", icon: Radio, to: "/canli-yayin" },
  { id: "dua-bagisi", label: "Dua Bağışı", icon: HeartHandshake, to: "/dua-bagisi" },
  { id: "duyurular", label: "Duyurular", icon: Bell, to: "/duyurular" },
  { id: "kayitlar", label: "Kayıtlar", icon: ClipboardList, to: "/kayitlar" },
  { id: "gecmis-sohbetler", label: "Geçmiş Sohbetler", icon: History, to: "/gecmis-sohbetler" },
].filter(item => !["ilahiler", "evrad-zikar", "kasideler"].includes(item.id));

export const heroContent = {
  title: ["İrfanla Aydınlanan", "Bir Yolculuk"],
  subtitle:
    "Geçmişten bugüne uzanan ilim, irfan ve hizmet yolu… Mahmut Efendim'in mirasıyla, Dergâhının bereketiyle…",
  searchPlaceholder: "Sayyâdî'ye bir şey sor…",
  filters: [
    "Mahmut Efendim AI · Sohbetler ve Kütüphane",
    "Tüm Kaynaklar",
    "Sohbetler",
    "Kütüphane",
    "İlahiler",
    "Evrad & Zikâr",
    "Kasideler",
  ],
};

export const quickActions = [
  { id: "ornek", label: "Örnek sorular", icon: Sparkles },
  { id: "rastgele", label: "Rastgele bir konu", icon: Shuffle },
  { id: "gelismis", label: "Gelişmiş arama", icon: SlidersHorizontal },
  { id: "acik", label: "Sadece herkese açık içerikte ara", icon: Users },
];

export const exampleQuestions = [
  "Tasavvufta nefs mertebeleri nelerdir?",
  "Evrad-ı Kudsiye nasıl okunur?",
  "Mahmut Efendim'in sohbetlerinde edep konusu",
  "Zikir çeşitleri ve âdabı nedir?",
  "Rabıta nedir, nasıl yapılır?",
  "Sahabe efendilerimizin hizmet anlayışı",
];

export const randomTopics = [
  "Edep ve Hayâ",
  "Sabır ve Tevekkül",
  "Gönül Terbiyesi",
  "İhlas ve Samimiyet",
  "Zikir ve Teveccüh",
  "Hizmet Ahlakı",
];

export const mainCards = [
  {
    id: "mahmut-efendim-ai",
    title: "Mahmut Efendim AI",
    desc: "Sohbet kayıtlarını keşfedin. Kaynaklı cevap hizmeti için doğrulama çalışmaları sürüyor.",
    cta: "Mahmut Efendim AI’ı aç",
    to: "/mahmut-efendim-ai",
    image: "/mahmut-efendim.jpg",
    imgPos: "center 26%",
    imgOpacity: 0.5,
    stats: [
      { icon: Play, label: "Video arşivi" },
      { icon: MessageCircle, label: "Soru-cevap" },
      { icon: FileText, label: "Transkriptler" },
    ],
  },
  {
    id: "ayak-izleri",
    title: "Dijital Ayak İzleri",
    desc: "Video, fotoğraf, belge, yazı ve tüm dijital arşivi tek yerde.",
    cta: "Arşive Git",
    to: "/ayak-izleri",
    image: IMAGES.whirlingDervish,
    stats: [
      { icon: Play, label: "Video" },
      { icon: ImageIcon, label: "Fotoğraf" },
      { icon: FileText, label: "Belgeler" },
      { icon: BookMarked, label: "Yazılar" },
    ],
  },
  {
    id: "kutuphane",
    title: "Dijital Kütüphane",
    desc: "İslâm eserleri kataloğu. Katalog araması ile sayfa ve pasaj incelemesi ayrı aşamalardır.",
    cta: "Kütüphaneye Git",
    to: "/kutuphane",
    image: IMAGES.ornateBook,
    stats: [
      { icon: BookOpen, label: "Eser kataloğu" },
      { icon: Layers, label: "Kategoriler" },
      { icon: FileText, label: "Kaynak bilgileri" },
    ],
  },
  {
    id: "dergah-kutuphanesi", title: "Dergâh Kütüphanesi",
    desc: "Dergâhtaki fiziki kitaplar. Kitabı bulun; oda, dolap ve raf konumunu görün.",
    cta: "Raf Kataloğunu Aç", to: "/dergah-kutuphanesi",
    stats: [{icon: BookOpen,label: "Fiziki kitaplar"},{icon: Layers,label: "Dolap ve raf"}],
  },
  {id: "kuran-dinle", title: "Kur’an Dinle ve Takip Et", desc: "Tilaveti dinletin; sure ve ayeti bulun, metni takip edin.", cta: "Dinlemeyi Aç", to: "/kuran-dinle", stats: [{icon: Mic, label: "Sesten ayet bul"}, {icon: BookOpen, label: "Ayet takibi"}]},
];

export const sectionCards = [
  {
    id: "dervisin-yolculugu",
    title: "Dervişin Yolculuğu",
    desc: "İlahiler, evrad, ezkâr, kasideler, sözlük, kavramlar, rehber içerikler.",
    cta: "Keşfet",
    to: "/dervisin-yolculugu",
    icon: Moon,
    image: IMAGES.mosqueDusk,
    wide: true,
  },
  {
    id: "ilahiler",
    title: "İlahiler",
    desc: "578 eser · 27 makam",
    cta: "Dinle",
    to: "/ilahiler",
    icon: Music2,
    image: IMAGES.neyFlute,
  },
  {
    id: "evrad-zikar",
    title: "Evrad & Zikâr",
    desc: "Günlük evradlar, ezkârlar ve hizipler.",
    cta: "İncele",
    to: "/evrad-zikar",
    icon: KeyRound,
    image: IMAGES.prayerBeads,
  },
  {
    id: "kasideler",
    title: "Kasideler",
    desc: "Seçme kasideler ve metinleri.",
    cta: "Oku",
    to: "/kasideler",
    icon: BookMarked,
    image: IMAGES.manuscript1,
  },
  {
    id: "konular",
    title: "Konular",
    desc: "Akaid, fıkıh, tasavvuf, ahlak, siyer ve daha fazlası.",
    cta: "Gözat",
    to: "/konular",
    icon: Layers,
    image: IMAGES.quranBeads,
  },
].filter(item => !["ilahiler", "evrad-zikar", "kasideler"].includes(item.id));

export const bottomCards = [
  {
    id: "haftalik-dersler",
    title: "Haftalık Dersler",
    desc: "Güncel ve geçmiş haftalık dersler",
    cta: "Derslere Git",
    to: "/haftalik-dersler",
    icon: CalendarDays,
    image: IMAGES.lantern1,
    accent: "gold",
  },
  {
    id: "canli-yayin",
    title: "Canlı Yayın",
    desc: "Yayın saatlerini görüntüleyin",
    cta: "Yayın Akışı",
    to: "/canli-yayin",
    icon: Radio,
    image: IMAGES.mosqueSunset,
    accent: "red",
  },
  {
    id: "dua-bagisi",
    title: "Dua Bağışı",
    desc: "Hatim, Salâtü Selâm, Kelime-i Tevhid, Sure ve Tesbihat bağışlayın",
    cta: "Dua Gönder",
    to: "/dua-bagisi",
    icon: HeartHandshake,
    image: IMAGES.prayingHands,
    accent: "gold",
  },
];

export const userProfile = {
  name: "Yavuz Selim Yaşar",
  role: "Sayyâdî Dervişi",
  loggedIn: false,
};

export const Icons = { Star, User };
